
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.958 33.05h2.768c.829 0 1.463-.22 1.901-.664.438-.444.657-1.093.657-1.949V18.53c0-.575.06-1.073.18-1.494.118-.421.288-.8.507-1.136l.736-1.103c.31-.486.55-.952.72-1.4.17-.447.256-.93.256-1.447v-.92H14v.92c0 .517.084 1 .252 1.447a7.3 7.3 0 00.725 1.4l.727 1.103c.22.336.389.715.508 1.136.119.42.179.919.179 1.494v11.907c0 .856.22 1.505.661 1.949.441.443 1.076.665 1.906.665zm1.387-15.683c.521 0 .94.17 1.255.513.315.343.472.783.472 1.322v3.249c0 .53-.157.962-.472 1.292-.315.33-.734.5-1.255.508-.526.007-.946-.156-1.261-.49-.315-.334-.473-.771-.473-1.31v-3.249c0-.539.158-.98.473-1.322.315-.342.735-.513 1.261-.513zm0 .898a1.04 1.04 0 00-.75.311 1.005 1.005 0 00-.319.747c0 .282.107.53.32.74.212.212.462.317.75.317.282 0 .528-.105.738-.317.21-.21.315-.458.315-.74 0-.29-.105-.54-.315-.747a1.018 1.018 0 00-.739-.31zM14 9.377h12.683v-.763c0-.861-.22-1.512-.661-1.953C25.58 6.221 24.945 6 24.116 6h-7.549c-.83 0-1.464.22-1.905.661C14.22 7.102 14 7.753 14 8.614v.763z","fill":"#12181D","fill-rule":"nonzero"}})])
          )
        }
      }
    